import { components } from "@/types/openapi";
import _ from "lodash";
import { Format } from "@/lib/wca/data/formats";
import { orderResults } from "@/lib/live/orderResults";
import { LiveResultsByRegistrationId } from "@/providers/LiveResultProvider";
import { LiveResult, LiveRound } from "@/types/live";

export type CompetitorWithResults = components["schemas"]["LiveCompetitor"] &
  Pick<LiveRound, "results"> &
  Pick<LiveResult, "advancing_questionable" | "advancing" | "global_pos">;

export const mergeAndOrderResults = (
  resultsByRegistrationId: LiveResultsByRegistrationId,
  competitors: Map<number, components["schemas"]["LiveCompetitor"]>,
  format: Format,
  forecastView = false,
): CompetitorWithResults[] => {
  const orderedResultsByRegistrationId = _.mapValues(
    resultsByRegistrationId,
    (results) => orderResults(results, format, forecastView),
  );

  const bestResultsPerCompetitor = Object.values(
    orderedResultsByRegistrationId,
  ).map((results) => results[0]);

  const globallyOrderedResults = orderResults(
    bestResultsPerCompetitor,
    format,
    forecastView,
  );

  return globallyOrderedResults.map((result) => {
    const competitor = competitors.get(result.registration_id)!;

    return {
      ...competitor,
      global_pos: result.global_pos,
      advancing: result.advancing,
      advancing_questionable: result.advancing_questionable,
      results: orderedResultsByRegistrationId[result.registration_id],
    };
  });
};
